(function (window) {
  window.SC.soulcupAnalytics = {};

  /**
   * Create the analytics manager
   *
   * @param {string} screenName name identifying the screen
   * @param {Object} initialState state to initialize common tracking data
   * @returns {Object} wrapped analytics
   */
  function createAnalyticsManager(screenName, initialState) {
    var state = Object.assign({
      'Enrollment Status': 'Enrolled',
      'Team Status': '',
      'Team ID': '',
      'Screen name': screenName
    }, initialState);

    /**
     * Update the fields used to track
     *
     * @param {Object} newState event to track
     * @returns {undefined}
     */
    function update(newState) {
      var validState = Object.keys(newState).reduce(function (acc, key) {
        if (state.hasOwnProperty(key)) {
          acc[key] = newState[key];
        }
        return acc;
      }, {});

      state = Object.assign(state, validState);
    }

    /**
     * Track via mParticle
     *
     * @param {string} eventName event to track
     * @param {string} source event trigger
     * @param {Object} extraData extra event data
     * @returns {undefined}
     */
    function track(eventName, source, extraData) {
      var fullEventName = ['SoulCup', eventName].join(' - ');
      var eventData = Object.assign({}, state, {
        Source: source
      }, extraData);

      function doTrack() {
        if (typeof window.mParticle !== 'undefined' && typeof window.mParticle.EventType !== 'undefined') {
          SC.analytics.mp.logEvent(fullEventName, 'navigation', eventData);
          return;
        }

        // Try again after 200 ms if analytics was not yet available
        setTimeout(doTrack, 200);
      }

      doTrack();
    }

    return {
      track: track,
      update: update
    };
  }

  window.SC.soulcupAnalytics.createAnalyticsManager = createAnalyticsManager;
})(window, jQuery);
